import React from 'react';
import PropTypes from 'prop-types';

import withConfig from 'HOCs/withConfig/withConfig';
import Image from 'Components/Image/Image';
import { convertToAbsoluteImageURI } from 'Helpers/images';
import { PNG_EXT, X, XX, XXX, SVG_EXT, MODE } from 'Constants/images';

export const ImageWrapper = props => {
    const { config,
        className,
        fileName,
        alt,
        types,
        supportForDifferentSize,
        defaultImageExtension,
        addSVG,
        fileSize,
        mode,
        ...rest } = props;
    const staticAssetsUrl = config.get('staticAssets');
    const differentSourceTypes = {};
    const additionalTypes = [];
    const theme = config.get('theme', 'id');

    types?.forEach(type => {
        if (type === SVG_EXT) {
            differentSourceTypes[type] = convertToAbsoluteImageURI(fileName, type, staticAssetsUrl, X, mode, theme);
        }
        else {
            differentSourceTypes[type] = supportForDifferentSize
                ? `${convertToAbsoluteImageURI(fileName, type, staticAssetsUrl, X, mode, theme)} 360w,
                ${convertToAbsoluteImageURI(fileName, type, staticAssetsUrl, XX, mode, theme)} 720w,
                ${convertToAbsoluteImageURI(fileName, type, staticAssetsUrl, XXX, mode, theme)} 1080w`
                : convertToAbsoluteImageURI(fileName, type, staticAssetsUrl, fileSize, mode, theme);
        }
    });

    if (addSVG) {
        differentSourceTypes[SVG_EXT] = convertToAbsoluteImageURI(fileName, SVG_EXT, staticAssetsUrl, X, '', theme);
        additionalTypes.push(SVG_EXT);
    }

    return (<Image
        sourceConfig={ differentSourceTypes }
        src={ convertToAbsoluteImageURI(fileName, defaultImageExtension, staticAssetsUrl, fileSize, mode, theme) }
        className={ className }
        alt={ alt }
        types={ additionalTypes.concat(types) }
        { ...rest } />)
    ;
};

ImageWrapper.propTypes = {
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    className: PropTypes.string,
    fileName: PropTypes.string.isRequired,
    alt: PropTypes.string,
    types: PropTypes.array,
    supportForDifferentSize: PropTypes.bool,
    defaultImageExtension: PropTypes.string,
    addSVG: PropTypes.bool,
    fileSize: PropTypes.string,
    mode: PropTypes.string
};

ImageWrapper.defaultProps = {
    className: '',
    alt: '',
    types: [],
    supportForDifferentSize: false,
    defaultImageExtension: PNG_EXT,
    addSVG: false,
    fileSize: X,
    mode: MODE.LIGHT
};

export default withConfig(ImageWrapper);
